import React, { useState, useEffect } from "react";
import "./CareersPage.scss";
import { createCareersList } from "services/careers/careers";
import { getServicesList } from "services/serviceslist/services";

const Careers = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    location: "",
    service: "",
  });

  const [errors, setErrors] = useState({});
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    fetchServiceList();
  }, []);

  const fetchServiceList = async () => {
    try {
      const res = await getServicesList({ page: 1, limit: 50 });
      if (res?.data?.services) {
        setServices(res.data.services);
      }
    } catch (error) {
      console.log("Error fetching services", error);
    }
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.name || formData.name.trim().length < 3) {
      newErrors.name = "Please enter a valid name (min 3 characters)";
    }

    if (!/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!formData.location || formData.location.trim().length < 3) {
      newErrors.location = "Location must be at least 3 characters";
    }

    if (!formData.service) {
      newErrors.service = "Please select a service";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "mobile") {
      value = value.replace(/[^0-9]/g, "").slice(0, 10);
    }

    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    if (!validate()) return;

    setLoading(true);

    try {
      const response = await createCareersList(formData);

      if (response.code === 200) {
        setSuccessMsg("Your application has been submitted successfully!");
        setFormData({ name: "", mobile: "", location: "", service: "" });
        setErrors({});
      } else {
        setErrorMsg("Something went wrong. Please try again.");
      }
    } catch (error) {
      setErrorMsg("Failed to submit. Check your connection.");
    }

    setLoading(false);
  };

  return (
    <div className="careers-wrapper">

      {/* HERO */}
      <section className="careers-hero">
        <h1>Join Our Team</h1>
        <p>Build a rewarding career with Sahyog Healthcare. Apply today.</p>
      </section>

      <div className="careers-flex">

        {/* LEFT */}
        <div className="careers-info">
          <h2>Why Work With Us?</h2>
          <p className="info-text">
            We provide excellent opportunities for caregivers, nurses, and support staff.
          </p>

          <div className="careers-highlights">
            <h3>✔ Professional Growth</h3>
            <p>Training & skill development for all staff.</p>
          </div>

          <div className="careers-highlights">
            <h3>✔ Flexible Work</h3>
            <p>Choose shifts that match your lifestyle.</p>
          </div>

          <div className="careers-highlights">
            <h3>✔ Supportive Environment</h3>
            <p>Work with a caring and respectful team.</p>
          </div>
        </div>

        {/* FORM */}
        <div className="careers-form">
          <h2>Apply Now</h2>

          {successMsg && <p className="c-success">{successMsg}</p>}
          {errorMsg && <p className="c-error">{errorMsg}</p>}

          <form onSubmit={handleSubmit}>

            <div className="c-field">
              <label>Your Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? "c-invalid" : ""}
              />
              {errors.name && <span className="c-err-text">{errors.name}</span>}
            </div>

            <div className="c-field">
              <label>Mobile Number *</label>
              <input
                type="text"
                name="mobile"
                placeholder="Enter 10-digit number"
                value={formData.mobile}
                onChange={handleChange}
                className={errors.mobile ? "c-invalid" : ""}
              />
              {errors.mobile && <span className="c-err-text">{errors.mobile}</span>}
            </div>

            <div className="c-field">
              <label>Your Location *</label>
              <input
                type="text"
                name="location"
                placeholder="Your city / area"
                value={formData.location}
                onChange={handleChange}
                className={errors.location ? "c-invalid" : ""}
              />
              {errors.location && <span className="c-err-text">{errors.location}</span>}
            </div>

            <div className="c-field">
              <label>Service You Want to Apply For *</label>
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                className={errors.service ? "c-invalid" : ""}
              >
                <option value="">Select service</option>
                {services.map((srv) => (
                  <option key={srv.id} value={srv.title}>
                    {srv.title}
                  </option>
                ))}
              </select>
              {errors.service && <span className="c-err-text">{errors.service}</span>}
            </div>

            <button className="c-submit" type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Application"}
            </button>

          </form>
        </div>
      </div>

      {/* ================= EXTRA CONTENT SECTION (NEW) ================= */}

      <section className="career-extra">

        <h2>Career Opportunities at Sahyog Healthcare</h2>
        <p className="extra-intro">
          We offer multiple roles for skilled caregivers, nurses, attendants, 
          patient care takers, and support staff.
        </p>

        <div className="roles-grid">
          <div className="role-box">
            <h3>👩‍⚕️ Nurse (ANM / GNM)</h3>
            <p>Provide medical support and patient care at home or hospital.</p>
          </div>
          <div className="role-box">
            <h3>🧓 Elder Care Attendant</h3>
            <p>Assist senior citizens with daily tasks and emotional support.</p>
          </div>
          <div className="role-box">
            <h3>🏥 Patient Care Assistant</h3>
            <p>Help patients with hygiene, mobility, and medication.</p>
          </div>
          <div className="role-box">
            <h3>🧹 Housekeeping & Support Staff</h3>
            <p>Maintain cleanliness and support the facility environment.</p>
          </div>
        </div>

      

      </section>

    </div>
  );
};

export default Careers;
